var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{on:{"click":function($event){return _vm.generateDynamicLink(_vm.id,_vm.route,_vm.additionalParams)}}},[_c('feather-icon',{attrs:{"icon":"CopyIcon"}}),_c('span',[_vm._v(" Copy Link ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }